import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import dayjs from 'vue-dayjs'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCarousel from 'vue-carousel';
import AOS from 'aos'
import VueAgile from 'vue-agile'
import 'aos/dist/aos.css';
import VueMeta from 'vue-meta';


import {url} from './global/index'; 

Vue.use(dayjs)


Vue.use(VueCarousel);
Vue.use(VueAxios, axios)

axios.defaults.baseURL =url;

Vue.config.productionTip = false

Vue.use(VueAgile)

Vue.use(VueMeta);

new Vue({
  router,
  store, 
  mounted() {
    AOS.init()
  },
  render: h => h(App),
}).$mount('#app')
